import { render, staticRenderFns } from "./CTimeButtons4.vue?vue&type=template&id=774724f0&scoped=true"
import script from "./CTimeButtons4.vue?vue&type=script&lang=js"
export * from "./CTimeButtons4.vue?vue&type=script&lang=js"
import style0 from "./CTimeButtons4.vue?vue&type=style&index=0&id=774724f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774724f0",
  null
  
)

export default component.exports